import BaseEntity from "./BaseEntity";
import OpportunityEntity from "./OpportunityEntity";

export default class ContactNoteEntity extends BaseEntity {
    private _note: string;
    private _subject: string;
    private _mood: string;
    private _date: string;
    private _contactTypeId: number;
    private _createdAt: string;
    private _opportunity: OpportunityEntity;
    private _opportunityId: number;

    public get Note(): string {
        return this._note;
    }

    public set Note(value: string) {
        this._note = value;
    }

    public get Subject(): string {
        return this._subject;
    }

    public set Subject(value: string) {
        this._subject = value;
    }

    public get Mood(): string {
        return this._mood;
    }

    public set Mood(value: string) {
        this._mood = value;
    }

    public get Date(): string {
        return this._date;
    }

    public set Date(value: string) {
        this._date = value;
    }

    public get ContactTypeId(): number {
        return this._contactTypeId;
    }

    public set ContactTypeId(value: number) {
        this._contactTypeId = value;
    }

    public get CreatedAt(): string {
        return this._createdAt;
    }

    public set CreatedAt(value: string) {
        this._createdAt = value;
    }

    public get Opportunity(): OpportunityEntity {
        return this._opportunity;
    }

    public set Opportunity(value: OpportunityEntity) {
        this._opportunity = value;
    }

    public get OpportunityId(): number {
        return this._opportunityId;
    }

    public set OpportunityId(value: number) {
        this._opportunityId = value;
    }

    static fromOdata(odataItem: any, entity: ContactNoteEntity): ContactNoteEntity {
        super.fromOdata(odataItem, entity);
        entity.Note = odataItem["Note"];
        entity.Subject = odataItem["Subject"];
        entity.Mood = odataItem["Mood"];
        entity.Date = odataItem["Date"];
        entity.ContactTypeId = odataItem["ContactTypeId"];
        entity.CreatedAt = odataItem["CreatedAt"];
        entity.Opportunity = odataItem["Lead"] ? OpportunityEntity.fromOdata(odataItem["Lead"], new OpportunityEntity()) : null;
        return entity;
    }

    static toOdataObject(contactNote: ContactNoteEntity): any {
        return {
            Note: contactNote.Note,
            Subject: contactNote.Subject,
            Mood: contactNote.Mood,
            Date: contactNote.Date,
            ContactTypeId: contactNote.ContactTypeId,
            LeadId: contactNote.OpportunityId,
        };
    }
}
